import RootApiService from '../RootApiService';

export default {
  async list(clubId, playerId) {
    return (await RootApiService.api.get(`/clubs/${clubId}/profile-requests`, { params: { playerId } })).data.data;
  },
  async create(clubId, playerId, after, reason) {
    return (await RootApiService.api.post(`/clubs/${clubId}/players/${playerId}/profile-requests`, { data: { after, reason } })).data.data;
  },
  async act(clubId, requestId, action, comment = '') {
    return (await RootApiService.api.post(`/clubs/${clubId}/profile-requests/${requestId}/action`, { data: { action, comment } })).data.data;
  },
};
